/**
 * Shared loading skeleton primitives (§7g).
 *
 * Wraps the `.skeleton` CSS classes already in global.css. Home.jsx
 * inlines these today; components added in 7g should use this wrapper
 * so the shape is consistent across the app.
 *
 * Variants:
 *   - "line"   — horizontal bar for text placeholders. Honours `size`.
 *   - "avatar" — round block for persona avatars in list placeholders.
 *   - "card"   — full card skeleton (avatar + 2 lines) for project /
 *                persona grid placeholders.
 *
 * `size` on the line variant: "xs" | "sm" | "md" (default) | "short".
 */
export default function LoadingSkeleton({
  variant = "line",
  size = "md",
  className = "",
}) {
  if (variant === "avatar") {
    return <div className={`skeleton skeleton-avatar ${className}`} />;
  }

  if (variant === "card") {
    return (
      <div className={`persona-card persona-card-skeleton ${className}`}>
        <div className="persona-card-header">
          <div className="skeleton skeleton-avatar" />
          <div style={{ flex: 1 }}>
            <div className="skeleton skeleton-line skeleton-line-sm" />
            <div className="skeleton skeleton-line skeleton-line-xs" />
          </div>
        </div>
        <div className="skeleton skeleton-line" />
        <div className="skeleton skeleton-line skeleton-line-short" />
      </div>
    );
  }

  // Default: line
  const sizeClass =
    size === "xs"
      ? "skeleton-line-xs"
      : size === "sm"
        ? "skeleton-line-sm"
        : size === "short"
          ? "skeleton-line-short"
          : "";
  return <div className={`skeleton skeleton-line ${sizeClass} ${className}`} />;
}
